import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import LiteYoutubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

const StyledEmbed = styled.div`
  overflow: hidden;
  margin-bottom: 2rem;
  border-radius: 1rem;
`

const YouTubeEmbed = ({ id, link, poster, ...rest }) => {
  const videoId = id || link?.split("v=")[1]
  if (!videoId) return null

  return (
    <StyledEmbed {...rest}>
      <LiteYoutubeEmbed
        id={videoId}
        title="Klipfolio YouTube"
        poster={poster}
      />
    </StyledEmbed>
  )
}

YouTubeEmbed.propTypes = {
  id: PropTypes.string,
  link: PropTypes.string,
}

export default YouTubeEmbed
